import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import WarningButton from "components/WarningButton";
import DeleteIcon from "@material-ui/icons/Delete";

const PlayerDeleteDialog = (props) => {
  const { open, playerGames, handleCancel, handleDelete } = props;

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Delete Player</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The last few games the player participated in are shown below. The
          records of the player's participation on these and all other games
          will be deleted if the player is deleted.
        </DialogContentText>
        {playerGames && playerGames.length > 0 ? (
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Game Id</TableCell>
                  <TableCell>Game Date</TableCell> <TableCell>Home</TableCell>
                  <TableCell>Away</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {playerGames.map((playerGame, index) => (
                  <TableRow key={playerGame.id}>
                    <TableCell component="th">
                      {playerGame.teamGame.game.id}
                    </TableCell>
                    <TableCell component="th">
                      {playerGame.teamGame.game.gameDateString}
                    </TableCell>
                    <TableCell component="th">
                      {playerGame.teamGame.game.home.season.team.school.name}
                    </TableCell>
                    <TableCell component="th">
                      {playerGame.teamGame.game.away.season.team.school.name}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div>No Games</div>
        )}
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <WarningButton label="Delete" onClick={handleDelete}>
            <DeleteIcon />
          </WarningButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default PlayerDeleteDialog;
